export default __webpack_public_path__ + "static/media/4-2_image14@2x.053ea87f.png";